import React from "react";
import styled, { css } from "styled-components";
import { Avatar } from "@sonder/ui/source/icons";
import { PlainButton } from "@sonder/ui/source/styled/fragments/PlainButton";
import { colors, typeface } from "@sonder/ui/source/styled/theme";

const AvatarBaseStyles = css`
  align-items: center;
  background: ${colors.white};
  border-radius: 50%;
  border: 1px solid ${colors.grayE};
  box-sizing: border-box;
  color: ${colors.gray4};
  display: inline-flex;
  height: 2rem;
  justify-content: center;
  user-select: none;
  width: 2rem;
  flex-shrink: 0;
`;

export const AvatarText = styled.span`
  ${AvatarBaseStyles};
  font-family: ${typeface.primary};
  font-size: 0.75rem;
`;

export const AvatarImage = styled.img`
  ${AvatarBaseStyles}
  border: none;
  object-fit: cover;
`;

export const AvatarIconWrapper = styled.span`
  ${AvatarBaseStyles}
  border: none;
  font-size: 2rem;
  > svg {
    color: inherit;
    font-size: inherit;
  }
`;

export const AvatarSvg = styled.span`
  ${AvatarBaseStyles}
  font-size: 1.25rem;
  > svg {
    color: inherit;
    font-size: inherit;
  }
`;

export const AvatarIcon = (props: React.HTMLAttributes<HTMLSpanElement>) => (
  <AvatarIconWrapper {...props}>
    <Avatar />
  </AvatarIconWrapper>
);

export const AvatarHoverStyles = css`
  ${AvatarImage} {
    opacity: 0.9;
  }
  &:hover:not(:disabled) {
    ${AvatarImage}, ${AvatarText} {
      opacity: 1;
    }
    ${AvatarIconWrapper}, ${AvatarImage}, ${AvatarText} {
      color: ${colors.black};
    }
  }
`;

export const AvatarButton = styled(PlainButton)`
  ${AvatarHoverStyles}
`;
